import { useContext } from 'react';
import { AppContext } from '../../Context/AppContext';
import './ToggleSearchTabs.scss';

export type TToggleSearchTabs = {
  data: any[];
  handleTabChange: (slug: string) => void;
};
const ToggleSearchTabs = ({ data, handleTabChange }: TToggleSearchTabs) => {
  const { isMobile } = useContext(AppContext);

  return (
    <div className="ToggleSearch_Container" data-testid="ToggleSearch_Container">
      {data?.map((item: any) => {
        if (isMobile && !item?.MobTitle) return null;
        return (
          <div
            key={item?.slug}
            className={`ToggleSearch_Tab ${item?.slug} ${item?.selected ? 'selected' : ''}`}
            onClick={() => handleTabChange(item?.slug)}
            data-testid={item?.slug}
          >
            {isMobile ? item?.MobTitle : item?.WebTitle}
          </div>
        );
      })}
    </div>
  );
};

export default ToggleSearchTabs;
